/* ==========================================================================
   Siraat — shared sale countdown driver
   One source of truth for EVERY countdown, on EVERY page: the PDP banner
   (.siraat-pts) and the announcement-bar countdown (.siraat-cd) both use
   [data-siraat-timer] markup with [data-unit="hours|mins|secs"].

   The end time is persisted in localStorage ('siraat_sale_end'), so the
   countdown runs CONTINUOUSLY across page navigations and tabs instead of
   restarting on every page load. A single lightweight interval re-reads that
   one shared end and re-queries every timer each pass, so all countdowns stay
   perfectly in sync and freshly-rendered timers (after a size-selector section
   re-render) are picked up automatically — with no DOM observer, so there is
   no reaction to unrelated page/app DOM churn (that caused the jank).
   Evergreen: at zero it reseeds to 2h 43m and persists the new end.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__siraatSaleLoop) return; /* exactly one loop, even if this asset loads twice */
  window.__siraatSaleLoop = true;

  var KEY = 'siraat_sale_end';
  var DURATION = (2 * 60 * 60 * 1000) + (43 * 60 * 1000); /* 2h 43m */

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function readStore() {
    try {
      var v = parseInt(localStorage.getItem(KEY), 10);
      if (!isNaN(v) && v) return v;
    } catch (e) {}
    return window.__siraatSaleEnd || 0; /* fallback/cache when localStorage is blocked */
  }
  function writeStore(v) {
    window.__siraatSaleEnd = v; /* always cache so it never re-seeds every tick */
    try { localStorage.setItem(KEY, String(v)); } catch (e) {}
  }

  /* single source of truth: persisted end, re-seeded only when missing/elapsed */
  function sharedEnd() {
    var e = readStore();
    if (!e || (e - Date.now()) <= 0) {
      e = Date.now() + DURATION;
      writeStore(e);
    }
    return e;
  }

  function set(el, unit, val) {
    var n = el.querySelector('[data-unit="' + unit + '"]');
    if (n && n.textContent !== val) n.textContent = val; /* write only on change */
  }

  function tick() {
    var diff = sharedEnd() - Date.now();
    if (diff < 0) diff = 0;
    var h = Math.floor(diff / 3600000); diff -= h * 3600000;
    var m = Math.floor(diff / 60000);   diff -= m * 60000;
    var s = Math.floor(diff / 1000);
    var hp = pad(h), mp = pad(m), sp = pad(s);
    var els = document.querySelectorAll('[data-siraat-timer]');
    for (var i = 0; i < els.length; i++) {
      set(els[i], 'hours', hp);
      set(els[i], 'mins', mp);
      set(els[i], 'secs', sp);
    }
  }

  function boot() {
    tick();
    setInterval(tick, 250); /* 4x/sec: smooth, and new elements are picked up within 250ms */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
